// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IProofOfExpensesCardTypePropertyDto
 */
export interface IProofOfExpensesCardTypePropertyDto {
    /**
     * 
     * @type {string}
     * @memberof IProofOfExpensesCardTypePropertyDto
     */
    proof_of_expenses_card_type?: IProofOfExpensesCardTypePropertyDtoProofOfExpensesCardTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof IProofOfExpensesCardTypePropertyDto
     */
    proof_of_expenses_type_state?: IProofOfExpensesCardTypePropertyDtoProofOfExpensesTypeStateEnum;
}

/**
* @export
* @enum {string}
*/
export enum IProofOfExpensesCardTypePropertyDtoProofOfExpensesCardTypeEnum {
    RECEIPT_REQUIRED = 'RECEIPT_REQUIRED',
    NO_RECEIPT_REQUIRED = 'NO_RECEIPT_REQUIRED'
}
/**
* @export
* @enum {string}
*/
export enum IProofOfExpensesCardTypePropertyDtoProofOfExpensesTypeStateEnum {
    MODIFIABLE = 'MODIFIABLE',
    LOCKED = 'LOCKED',
    HIDDEN = 'HIDDEN',
    REQUIRED_AT_PLAN = 'REQUIRED_AT_PLAN',
    REQUIRED_AT_ALL_LEVELS = 'REQUIRED_AT_ALL_LEVELS'
}


/**
 * Check if a given object implements the IProofOfExpensesCardTypePropertyDto interface.
 */
export function instanceOfIProofOfExpensesCardTypePropertyDto(value: object): value is IProofOfExpensesCardTypePropertyDto {
    return true;
}

export function IProofOfExpensesCardTypePropertyDtoFromJSON(json: any): IProofOfExpensesCardTypePropertyDto {
    return IProofOfExpensesCardTypePropertyDtoFromJSONTyped(json, false);
}

export function IProofOfExpensesCardTypePropertyDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IProofOfExpensesCardTypePropertyDto {
    if (json == null) {
        return json;
    }
    return {
        
        'proof_of_expenses_card_type': json['proof_of_expenses_card_type'] == null ? undefined : json['proof_of_expenses_card_type'],
        'proof_of_expenses_type_state': json['proof_of_expenses_type_state'] == null ? undefined : json['proof_of_expenses_type_state'],
    };
}

export function IProofOfExpensesCardTypePropertyDtoToJSON(json: any): IProofOfExpensesCardTypePropertyDto {
    return IProofOfExpensesCardTypePropertyDtoToJSONTyped(json, false);
}

export function IProofOfExpensesCardTypePropertyDtoToJSONTyped(value?: IProofOfExpensesCardTypePropertyDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'proof_of_expenses_card_type': value['proof_of_expenses_card_type'],
        'proof_of_expenses_type_state': value['proof_of_expenses_type_state'],
    };
}

